<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1 style="color: #e04787;">Verification</h1>
            <ul>
                <li>
                    <a [routerLink]="['/required-configuration']" style="color: #e04787;"><i class="fa fa-reply "
                            aria-hidden="true"></i>
                        Back</a>
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="el-blog-single-wrapper el-blog-medium-wrapper pt-4">
    <div class="container">

        <div class="el-inner-blog-box el-blog-single-form" style="text-align: center;">
            <h4 class="el-blog-title">Photo </h4>

            <div class="cam" *ngIf="isShowCamera==false">
                <img src="{{PREP_UserInfo.profilePic}}"><br><br>
                <button class="el-btn py-4" (click)="openCamera()">Change Profile Picture</button><br><br>
                <a class="el-btn py-4" href="/exam">Proceed</a>
            </div>


            <div [hidden]="isShowCamera==false">
                <div id="camera-container">
                    <video id="CameraId" #CameraId autoplay style="width:320px;">
                    </video>
                    <div id="frame" #frame width="150" height="180"></div>
                </div>
                <canvas #canvas width="150" height="180" style="border: 1px solid red; display: none;"></canvas>


                <br>
                <button class="el-btn py-4" (click)="captureImage()">Capture</button> &nbsp;&nbsp;
                <button class="el-btn py-4" (click)="ngOnDestroy()">Cancel</button>
                <br><br>
                <br><br>

                <p style="color: red;">{{msg}}</p>
                <div *ngIf="capturedImage!=null">
                    <h4>Captured Image:</h4>
                    <img [src]="capturedImage" alt="Captured" />
                    <br><br>
                    <br><br>
                    <button class="el-btn py-4" (click)="Upload()">Upload</button>
                </div>
            </div>

        </div>
    </div>
</div>